import CTAButton from '../../../../../ui/ctaButton';
import ProtectedEmail from '../../../../../ui/protectedEmail';
import { ACCESS_CLIENT_PORTAL } from '../../constants';
import { Wrapper, ContentWrapper, TextContent, Title, Text } from './styles';

const AccessClientPortal = () => {
  return (
    <Wrapper>
      <ContentWrapper>
        <TextContent>
          <Title>{ACCESS_CLIENT_PORTAL.title}</Title>
          <Text>
            {ACCESS_CLIENT_PORTAL.textBefore}
            <ProtectedEmail email={ACCESS_CLIENT_PORTAL.email} />
            {ACCESS_CLIENT_PORTAL.textAfter}
          </Text>
        </TextContent>
        <CTAButton text={ACCESS_CLIENT_PORTAL.buttonText} onClick={ACCESS_CLIENT_PORTAL.onClick} />
      </ContentWrapper>
    </Wrapper>
  );
};

export default AccessClientPortal;
